import { SITE_PHOTOS } from '../sitePhotos';
import { useState } from 'react';
import ImageLightbox from './ImageLightbox';

export default function ConstructionPhotos() {
  const [image, setImage] = useState<string | null>(null);
  return (
    <section className="not-prose mt-10 border-t border-slate-200 pt-6" aria-label="Ảnh tư liệu thi công">
      <h2 className="text-xl font-bold text-primary-dark mb-4">Ảnh tư liệu thi công của đơn vị</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[SITE_PHOTOS[0], SITE_PHOTOS[2], SITE_PHOTOS[4]].map(photo => (
          <figure key={photo.id} className="m-0">
            <button type="button" onClick={() => setImage(photo.url)} className="block w-full cursor-zoom-in rounded-xl focus-visible:outline-2 focus-visible:outline-primary-dark" aria-label={`Xem ảnh đầy đủ: ${photo.caption}`}>
              <img src={photo.url} alt={photo.caption} loading="lazy" className="w-full aspect-[4/3] object-cover rounded-xl" />
            </button>
            <figcaption className="mt-2 text-sm text-slate-600 leading-relaxed">{photo.caption}</figcaption>
          </figure>
        ))}
      </div>
      <ImageLightbox image={image} onClose={() => setImage(null)} />
    </section>
  );
}
